import ProtectedRoute from "../../auth/ProtectedRoute";
import { Route, Routes, useLocation } from "react-router-dom";

import OldRoutes from "./OldRoutes";

const OverrideRoutes = ({
  navigateWorkspace,
  actualpage,
  version,
  userData,
  orgData,
  workspaceData,
  refreshFolders,
  masterData,
}) => {
  const location = useLocation();

  return (
    <Routes>
      <Route
        path="*"
        element={
          <OldRoutes
            path_prefix="imp/:id/workspace/:id"
            navigateWorkspace={navigateWorkspace}
            version={version}
            actualpage={actualpage}
            userData={userData}
            orgData={orgData}
            workspaceData={workspaceData}
            refreshFolders={refreshFolders}
            masterData={masterData}
          ></OldRoutes>
        }
      />
    </Routes>
  );
};

export default OverrideRoutes;
